const LitterSizes = {
  SMALL: { min: 4, max: 7 },
  LARGE: { min: 8, max: 11 },
};

function setQuantityForLitter(min: number, max: number) {
  const quantityInput = document.querySelector('#Quantity');
  if (quantityInput instanceof HTMLInputElement) {
    quantityInput.value = `${min}`;
    quantityInput.min = `${min}`;
    quantityInput.max = `${max}`;
  }
}

function updateQuantityMinMax(value: string) {
  const selectedSize = value.toLowerCase().includes('large')
    ? 'LARGE'
    : 'SMALL';

  const size = LitterSizes[selectedSize];
  setQuantityForLitter(size.min, size.max);
}

export function limitQuantityBasedOnVariant(): void {
  const selectedSize = window.embark.config?.PUPPY_PACK?.selectedSize;

  if (selectedSize) {
    updateQuantityMinMax(selectedSize);
  }

  const updateLineItemProperties = (title: string) => {
    const selectedSize = title.toLowerCase().includes('large')
      ? 'LARGE'
      : 'SMALL';
    const size = LitterSizes[selectedSize];
    document.querySelectorAll('input.properties-qty-min').forEach((el) => {
      if (el instanceof HTMLInputElement) {
        el.value = `${size.min}`;
      }
    });

    document.querySelectorAll('input.properties-qty-max').forEach((el) => {
      if (el instanceof HTMLInputElement) {
        el.value = `${Math.min(size.max * 2, 20)}`; // double the max quantity because we allow purchasing 2 packs in one order
      }
    });
  };

  document.addEventListener('variant:change', function (event) {
    const selected_variant = (event as CustomEvent)?.detail?.variant;
    updateQuantityMinMax(selected_variant?.title);
    updateLineItemProperties(selected_variant?.title);
  });
}
